import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 0px 20px 0px;
  width: 100%;
`;

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: 400px;
  width: 100%;
`;

export const FavoriteItem = styled.div`
  display: flex;
  align-items: center;
  padding: 6px 20px;
  cursor: pointer;
  transition: background-color 0.2s;
  background-color: transparent;
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};

  &:hover {
    background-color: ${({ theme }) => theme.colors.v2_secondary};
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const IconContainer = styled.div`
  margin-right: 8px;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.primary};
`;

export const FavoriteInfo = styled.div`
  display: flex;
  flex: 1;
`;


export const FavoriteName = styled.p`
  font-family: ${({ theme }) => theme.fonts.primaryFont};
  color: ${({ theme }) => theme.colors.darkText};
  font-size: 14px;
  font-weight: 500;
  flex: 1;
`;

export const DeleteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.error};
  width: 50px;
  height: 34px;
  border-radius: 4px;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(255, 0, 0, 0.1);
  }
`;

export const EmptyMessage = styled.p`
  font-family: ${({ theme }) => theme.fonts.primaryFont};
  color: ${({ theme }) => theme.colors.mediumText};
  font-size: 14px;
  text-align: center;
  padding: 30px;
`;

export const BatchControls = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const BatchCountInput = styled.input`
  width: 52px;
  height: 32px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 4px;
  padding: 4px 6px;
  font-size: 14px;
  text-align: center;
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.darkText};
  font-family: ${({ theme }) => theme.fonts.primaryFont};

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;

export const BatchIconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  width: 32px;
  height: 34px;
  border-radius: 4px;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${({ theme }) => theme.colors.v2_secondary};
  }
`;
